export default function createStyles(styles) {
  return styles;
}